
import { Card, CardContent } from "@/components/ui/card";
import { CalendarView } from "@/components/schedule/CalendarView";

interface ScheduleCalendarProps {
  selectedDate: Date;
  currentMonth: Date;
  onDateSelect: (date: Date) => void;
  onMonthChange: (month: Date) => void;
  compact?: boolean;
}

export function ScheduleCalendar({
  selectedDate,
  currentMonth,
  onDateSelect,
  onMonthChange,
  compact = false,
}: ScheduleCalendarProps) {
  return (
    <div className={compact ? "w-full" : "w-full max-w-xs mx-auto"}>
      <CalendarView 
        selectedDate={selectedDate}
        currentMonth={currentMonth}
        onDateSelect={onDateSelect}
        onMonthChange={onMonthChange}
        compact={compact}
      />
    </div>
  );
}
